const loginDefaultState = {
  access: false,
  access2FA: false,
  encryptedUserId: null,
  salt: null, // Hashed Security Salt
  email: null,
  // shopify page
  shopify: false,
  CrmId: ''
};

export default (state = loginDefaultState, action) => {
  let tempState = {...state};
  switch (action.type) {
    default:
      return tempState;
    case 'LOGIN_APP':
      tempState.access = !tempState.access;
      tempState.access2FA = false;
      tempState.hashedSecurityCode = null;
      tempState.email = action.email;
      tempState.shopify = false;
      return tempState;

    case 'LOGOUT_APP':
      tempState.access = !tempState.access;
      tempState.access2FA = false;
      tempState.hashedSecurityCode = null;
      tempState.shopify = false;
      return tempState;

    case 'LOGIN_APP_2FA':
      tempState.access2FA = !tempState.access2FA;
      tempState.shopify = false;
      return tempState;

    case 'LOGIN_APP_DITECTLY':
      tempState.access = !tempState.access;
      tempState.access2FA = !tempState.access2FA;
      tempState.hashedSecurityCode = null;
      tempState.email = action.email;
      tempState.shopify = true;
      return tempState;

    case "SET_USERNAME":
      tempState.userName = action.userName;
      return tempState;
    case "SET_CRMID":
      tempState.CrmId = action.CrmId;
      return tempState;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/login.js